<script setup lang="ts">
import type { NuxtError } from '#app';
// Direct import from icons-registry bypasses nuxt-svgo's async global registration,
// preventing the static/dynamic import conflict on the error page bundle
import ArrowNarrowLeft from 'assets/icons-registry/common/arrow-narrow-left.svg';

defineProps<{
  error?: NuxtError;
}>();
</script>

<template>
  <section class="grid min-h-screen-without-header w-full grid-cols-1 grid-rows-1 px-4 py-4">
    <div
      aria-hidden="true"
      class="col-start-1 row-start-1 flex items-center justify-center text-display-error font-semibold leading-none text-muted"
    >
      {{ error?.statusCode }}
    </div>
    <div
      class="col-start-1 row-start-1 mx-auto flex h-full w-full max-w-4xl flex-col items-center justify-center gap-8 sm:gap-16"
    >
      <div class="flex flex-col items-center gap-4 sm:gap-8">
        <h1 class="text-center text-4xl font-semibold sm:text-5xl">{{ $t('components.common.error.pageNotFound') }}</h1>
        <div
          v-if="useMetaDevelopment()"
          class="rounded-xl border border-foreground bg-secondary shadow-xl"
        >
          <div class="border-b border-foreground px-4 py-3 text-sm font-semibold text-foreground">
            {{ error?.statusCode }} - {{ error?.message }}
          </div>
          <pre
            class="overflow-auto whitespace-pre-wrap break-words p-4 font-mono text-sm leading-relaxed text-foreground"
          >
            <code>{{ error?.stack }}</code>
          </pre>
        </div>
        <p
          v-else
          class="max-w-lg text-center text-lg font-normal text-gray-600 sm:text-xl"
        >
          {{ $t('components.common.error.pageNotFoundDescription') }}
        </p>
      </div>
      <UiButton
        size="lg"
        shape="lg"
        class="gap-2.5 px-5 text-lg shadow"
        @click="reloadNuxtApp({ path: $localePath('index') })"
      >
        <ArrowNarrowLeft
          :font-controlled="false"
          filled
          aria-hidden="true"
          class="text-brand-primary-700"
        />
        <span>{{ $t('components.common.error.backToHome') }}</span>
      </UiButton>
    </div>
  </section>
</template>
